module.exports = __webpack_public_path__ + "img/DMO_Betrieb.38a5f832.svg";